module.exports = __webpack_public_path__ + "site/img/48.fd328608.jpg";